import { ref } from "vue";
import { selectedSingleDevice, state } from "./SearchDevice";
import { auth_list, GET_SERVER_REQUEST } from "./ServerConnect";
import { loadingStore } from "./LoadingStore";
import { showNotification } from "./Notification";

export const isMenuModalOpen = ref(false);    // 설정 페이지 열기/닫기

export const isToggleOn = ref(false);
export const isDeviceModalSimpleOpen = ref(false); // 개별 장치 관리 페이지 열기/닫기
export const isPathModalOpen = ref(false);       // 경로 확인 페이지 열기/닫기
export const showDeviceSimple = async (device, modalName = null) => {
  loadingStore.showLoading();
  if (!modalName) modalName = isToggleOn.value ? 'Path' : 'DeviceSimple';
  if (device) {
    const data = await GET_SERVER_REQUEST('device', '/?device_id='+device.device_id);
    selectedSingleDevice.value = { ...device, ...data[0] };
  }
  if (modalName === 'DeviceSimple') {
    // isDeviceModalSimpleOpen.value = true;
    const text = `${device.latitude}, ${device.longitude}`;
    navigator.clipboard.writeText(text)
    .then(() => {
      // console.log("클립보드 복사 완료:", text);
      showNotification(text + ' 복사 완료', 'info', 'top-center');
    })
    .catch(err => {
      console.error("클립보드 복사 실패:", err);
    });
    // console.log(device);
    loadingStore.hideLoading();
  }
  if (modalName === 'Path') isPathModalOpen.value = true;
  
  state.map.setView({lat: device.latitude, lng: device.longitude});
}

export const isAuthEditModalOpen = ref(false);
export const selectedAuth = ref(null);
export const showEditAuth = (auth = null) => {
  selectedAuth.value = auth;
  isAuthEditModalOpen.value = true;
};
export const closeEdithAuth = async () => {
  selectedAuth.value = null;
  isAuthEditModalOpen.value = false;
  auth_list.value = await GET_SERVER_REQUEST('auth');
}

export const showSmallModal = ref(false);

export const modalList = ref([
  { key: "User", isOpen: false, title: "manage_user", abled: false, depth: false },
  { key: "Device", isOpen: false, title: "manage_device", abled: true, depth: false },
  // { key: "Group", isOpen: false, title: "manage_group", abled: true, depth: false },
  { key: "Geo", isOpen: false, title: "manage_geofence", abled: true, depth: false },
  { key: "Auth", isOpen: false, title: "manage_authority", abled: true, depth: false },
  { key: "POI", isOpen: false, title: "manage_poi", abled: true, depth: false },
  { key: "Event", isOpen: false, title: "view_access_records", abled: true, depth: false },
  { key: "Log", isOpen: false, title: "view_logs", abled: true, depth: false },
  { key: "Operation", isOpen: false, title: "view_operation", abled: true, depth: false },
  { key: "CPE", isOpen: false, title:"manage_cpe", abled: true, depth: false},
  { key: "Live", isOpen: false, title: "manage_live_update", abled: true, depth: false },
  { key: "Statistics", isOpen: false, title: "view_statistics", abled: true, children: [
    { key: "AccessorS", isOpen: false, title: "accessor_statistics", abled: true },
    { key: "EntryExitS", isOpen: false, title: "entryexit_statistics", abled: true },
    { key: "WarnCountS", isOpen: false, title: "warncount_statistics", abled: true },
    // { key: "PersonnelS", isOpen: false, title: "personnel_statistics", abled: true },
    // { key: "DeviceS", isOpen: false, title: "device", abled: true },
  ] },
]);
export const nowSelectedDepth = ref(null);